import PropTypes from 'prop-types'

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import styles from './PersonDetail.module.scss'
import Heading from 'basics/Heading/Heading'
import Spacer from 'basics/Spacer/Spacer'
import { ClassNames } from 'services/classname.service'
import { PickFirst, PhoneLink } from 'services/utils'
import Image from 'basics/Image'
import Icon from 'basics/Icon'
import Link from 'basics/Link'
import useMarketo from 'hooks/useMarketo'
import MarketoForm from 'components/MarketoForm'

const PersonDetail = ({
  className,
  firstName,
  lastName,
  title,
  company,
  linkedInUrl,
  phoneNumber,
  email,
  cutoutImage,
  bioImage,
  associatedLocations = [],
  isLightTheme,
  shortBio,
  marketoid,
  thankYouPage
}) => {
  let companyShortDescription = ''
  const { onLoadForm, onRemoveForm, formLoaded, formSuccess } = useMarketo({
    munchkinId: '880-QNO-957',
    formId: marketoid,
    callback: () => {}
  })

  const [ isMounted, setIsMounted ] = useState( false );

  useEffect( () => {
    setIsMounted( true );
  }, [] );

  if (Array.isArray(company)) {
    const oldCompany = PickFirst(company) || {}
    company = oldCompany.name || ''
    companyShortDescription = oldCompany.shortDescription || ''
  }

  let image
  let isCutout = false
  if (bioImage && bioImage.length > 0) {
    const img = PickFirst(bioImage)
    const tmpImage = PickFirst(PickFirst(img.image)?.image)
    isCutout = img.cutout
    image = tmpImage?.fileName || ''
  }
  const phoneLink = PhoneLink(phoneNumber)

  return (
    <>
      <section
        className={ClassNames([
          styles['ds-person-detail'],
          styles['ds-person-detail--light'], //isLightTheme ? styles['ds-person-detail--light'] : '',
          'display-flex'
        ])}
      >
        <div className={styles['ds-person-detail__content']}>
          <p>
            <Link href="/about">About</Link> / <Link href="/representatives">Team</Link>
          </p>
          <Spacer size={4} />
          <Heading level={1} className="mb-3 h2">
            {firstName} {lastName}
          </Heading>

          <p className="intro-paragraph">{title}</p>

          <Spacer size={4} />

          <ul>
            <li>{company}</li>
            {companyShortDescription && <li>{companyShortDescription}</li>}
            {associatedLocations &&
              associatedLocations?.map((location, idx) => {
                return (
                  <li key={idx}>
                    <a
                      href={`/${PickFirst(location.pageBase)?.url || '#'}`}
                      className="chevron reverse"
                    >
                      {location.name}
                    </a>
                  </li>
                )
              })}
          </ul>

          <Spacer size={7} />

          <div className={styles['ds-person-detail__actions']}>
            {phoneNumber && (
              <span className={styles['action']}>
                <a href={phoneLink} className="mb-2">
                  <strong>{phoneNumber}</strong>
                </a>
              </span>
            )}
            {marketoid && (
              <span className={styles['action']}>
                <button onClick={onLoadForm}>
                  <Icon icon="envelope" onClick={onLoadForm} /> Message {firstName}
                </button>
              </span>
            )}
            {linkedInUrl && (
              <span className={styles['action']}>
                <Link href={linkedInUrl} external={true} className="mb-2">
                  <Icon icon="linkedin" className="" />
                </Link>
              </span>
            )}
          </div>
        </div>
        <div className={styles['ds-person-detail__image']}>
          {cutoutImage && (
            <Image
              src={cutoutImage}
              alt={`${firstName} ${lastName}`}
              className={styles['ds-person-detail__image--cutout']}
            />
          )}
          {image && (
            <Image
              src={image}
              alt={`${firstName} ${lastName}`}
              className={
                isCutout
                  ? styles['ds-person-detail__image--cutout']
                  : styles['ds-person-detail__image--image']
              }
            />
          )}
        </div>
      </section>
      
      { isMounted && createPortal(
        <MarketoForm
          formId={marketoid}
          isLoaded={formLoaded}
          onRemoveForm={onRemoveForm}
          success={formSuccess}
          successMessage="Thank you for taking the time to connect with me. I will follow-up with you soon."
          thankYouPage={thankYouPage}
        />, document.body
      )}
    </>
  )
}

PersonDetail.propTypes = {}

export default PersonDetail
